<template>
  <div>
    <!-- <v-btn color="primary" @click="signIn">
      sign in
    </v-btn>
    <v-btn color="primary" :to="`/signup`">
      sign up
    </v-btn>
    <v-btn color="primary" @click="logout">
      Logout
    </v-btn> -->
  </div>
</template>
<script lang="ts">
//import Vue from 'vue';
import { defineComponent } from "vue";
// import JwtDecode from 'jwt-decode';
import LocalDataService from '@/service/LocalDataService';
import { auth0Module } from '@/store/dataModules/auth0Module';
import { meModule } from '@/store/dataModules/meModule';

export default defineComponent({
  methods: {
    signIn() {
      // auth0Module.signinProcess();
      meModule.fetchMe();
    },
    logout() {
      // auth0Module.signinProcess();
      auth0Module.logout();
    },
  },
  async mounted() {
    // const code = this.$route.query.code;
    // const state = this.$route.query.state;
    // if (code && state) {
    //   this.$router.push('/');
    // }
  },
});
</script>
<style lang="scss" scoped></style>
